import { create } from 'zustand';
import { aparienciaApi } from '../utils/api';

/**
 * Tema visual de la cuenta (portado de Payroll360 SaaS):
 *  - 'finance360': identidad de Finance360, menú claro con el índigo como marca de agua
 *  - 'finance360-solido': identidad de Finance360, menú índigo oscuro sólido
 *  - 'clasico': el aspecto de siempre
 *
 * Lo manda el servidor (Configuración → Apariencia, o el SuperAdmin). Acá se recuerda el
 * último valor en el navegador solo para no mostrar un tema y saltar al otro mientras
 * llega la respuesta.
 */
const CLAVE = 'f360-tema';
const TEMAS = ['finance360', 'finance360-solido', 'clasico'];
const leerLocal = () => {
  try {
    const t = localStorage.getItem(CLAVE);
    return TEMAS.includes(t) ? t : 'clasico';
  } catch { return 'clasico'; }
};
const guardarLocal = (t) => { try { localStorage.setItem(CLAVE, t); } catch { /* sin almacenamiento */ } };

export const useTemaStore = create((set) => ({
  tema: leerLocal(),
  cargar: async () => {
    // Vista previa: `?vista=finance360` muestra un tema solo en este navegador, sin guardarlo
    try {
      const vista = new URLSearchParams(window.location.search).get('vista');
      if (TEMAS.includes(vista)) { sessionStorage.setItem('f360-vista', vista); }
      const enVista = sessionStorage.getItem('f360-vista');
      if (TEMAS.includes(enVista)) { set({ tema: enVista }); return; }
    } catch { /* sin almacenamiento */ }
    try {
      const { data } = await aparienciaApi.leer();
      guardarLocal(data.tema);
      set({ tema: data.tema });
    } catch (err) {
      console.error('No se pudo leer el tema:', err);
    }
  },
  cambiar: async (tema) => {
    const { data } = await aparienciaApi.cambiar(tema);
    guardarLocal(data.tema);
    set({ tema: data.tema });
  }
}));

/** true cuando la cuenta usa la identidad de Finance360 (cualquiera de sus dos variantes) */
export const useTemaNuevo = () => useTemaStore((s) => s.tema !== 'clasico');

/** true cuando el menú va con el índigo como marca de agua (y no sólido) */
export const useMarcaDeAgua = () => useTemaStore((s) => s.tema === 'finance360');
